/* eslint-disable no-undef */
import { Slider } from '../slider'
import { SplideSlide } from '@splidejs/react-splide'
import { Component, createRef } from 'preact'
import review1 from '../../assets/images/feedbacks/review-1.png'
import review2 from '../../assets/images/feedbacks/review-2.png'
import review3 from '../../assets/images/feedbacks/review-3.png'
import review4 from '../../assets/images/feedbacks/review-4.png'
import styles from './style.styl'
import { Regular } from '../text'

class Feedback extends Component {
  wrapperRef = createRef();
  state = {
    isInView: false
  }

  intesectionCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.setState({ isInView: true })
      }
    })
  }

  componentDidMount () {
    const observer = new IntersectionObserver(this.intesectionCallback, {
      rootMargin: '0% 0% 100% 0%',
      threshold: 0
    })

    observer.observe(this.wrapperRef.current)
  }

  render () {
    return (
      <div ref={this.wrapperRef} id={'reviews'} className={styles.section}>
        <div className={styles.feedback}>
          <Regular className={styles.title}>What our alumni say:</Regular>
          <div className={styles.feedbackGrid}>
            <div className={styles.feedbackImageWrapper}>
              <div className={styles.imageWrapper}>{this.state.isInView && <img src={review1} alt='review' className={styles.image} />}</div>
            </div>

            <div className={styles.feedbackImageWrapper}>
              <div className={styles.imageWrapper}>{this.state.isInView && <img src={review2} alt='review' className={styles.image} />}</div>
            </div>

            <div className={styles.feedbackImageWrapper}>
              <div className={styles.imageWrapper}>{this.state.isInView && <img src={review3} alt='review' className={styles.image} />}</div>
            </div>

            <div className={styles.feedbackImageWrapper}>
              <div className={styles.imageWrapper}>{this.state.isInView && <img src={review4} alt='review' className={styles.image} />}</div>
            </div>

          </div>
        </div>
        <div className={styles.feedbackMobile}>
          <Regular className={styles.title}>What our alumni say:</Regular>
          <Slider>
            <SplideSlide>
              <div className={styles.feedbackImageWrapper}>
                <div className={styles.imageWrapper}>{this.state.isInView && <img src={review1} alt='review' className={styles.image} />}</div>
              </div>
            </SplideSlide>

            <SplideSlide>
              <div className={styles.feedbackImageWrapper}>
                <div className={styles.imageWrapper}>{this.state.isInView && <img src={review2} alt='review' className={styles.image} />}</div>
              </div>
            </SplideSlide>

            <SplideSlide>
              <div className={styles.feedbackImageWrapper}>
                <div className={styles.imageWrapper}>{this.state.isInView && <img src={review3} alt='review' className={styles.image} />}</div>
              </div>
            </SplideSlide>

            <SplideSlide>
              <div className={styles.feedbackImageWrapper}>
                <div className={styles.imageWrapper}>{this.state.isInView && <img src={review4} alt='review' className={styles.image} />}</div>
              </div>
            </SplideSlide>
          </Slider>

        </div>
      </div>
    )
  }
}

export default Feedback



// WEBPACK FOOTER //
// ./components/feedback/index.js